import React from "react";
import MonthDay from "./MonthDay";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../../constants");

const daysInWeek = [...Array(7)].map((_, i) => i);

function MonthWeek({
  startOfWeek,
  handleSelectDate,
  selectedDates,
  scheduledSessions,
  handleRemoveMultiple,
  expanded = false,
}) {
  return (
    <article className={expanded ? " expanded" : ""}>
      {daysInWeek.map((day) => {
        const date = startOfWeek.clone().add(day, "days");
        const dayString = date.clone().format(DATE_DAY_FORMAT);
        const isSelected = selectedDates.includes(dayString);

        return (
          <MonthDay
            key={dayString}
            date={date}
            handleSelectDate={handleSelectDate}
            isSelected={isSelected}
            selectedDates={selectedDates}
            scheduledSessions={scheduledSessions}
            handleRemoveMultiple={handleRemoveMultiple}
            expanded={expanded}
          />
        );
      })}
    </article>
  );
}

export default MonthWeek;
